export const FEATURE_FLAG_MOVE_SCHEDULES = "moveSchedules"
